// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
    aws_project_region: 'eu-west-2',
    aws_cognito_identity_pool_id: 'eu-west-2:cc495fe9-8225-441c-89cb-a395e207f10e',
    aws_cognito_region: 'eu-west-2',
    aws_user_pools_id: 'eu-west-2_TwV4MgKRd',
    aws_user_pools_web_client_id: '4pp2jsp9u16jmsf8v1pfo3shfo',
    oauth: {
        domain: 'bs-suppliers-dev.auth.eu-west-2.amazoncognito.com',
        scope: [
            'phone',
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
        ],
        redirectSignIn: 'http://localhost:3000/callback/',
        redirectSignOut: 'http://localhost:3000/callback/',
        responseType: 'token',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_appsync_graphqlEndpoint: 'https://5qvl4vee2jdfde3hf6actgrf2m.appsync-api.eu-west-2.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
}
export default awsmobile
